const PHONE="351932507417";
const DISHES=[
  {id:"coxas",name:"Coxas de frango em molho de vinho branco, batata assada",desc:"Cozinhadas devagar no molho, com batata assada com alho e salsa.",al:"Sulfitos"},
  {id:"strogonoff",name:"Strogonoff de frango com arroz branco",desc:"Cremoso, com cogumelos e natas. Reaquece sem problemas.",al:"Leite"},
  {id:"alheira",name:"Lasanha de alheira e grelos",desc:"A alheira desfaz-se no molho e os grelos cortam a gordura. Gratinada no forno.",al:"Glúten · leite"},
  {id:"lombo",name:"Lombo de porco com molho de laranja, batata-doce assada",desc:"Fatias de lombo em molho de laranja, com batata-doce assada.",al:"—"},
  {id:"salmao",name:"Arroz de salmão teriyaki com brócolos",desc:"Salmão em pedaços, arroz com molho teriyaki e brócolos.",al:"Peixe · soja · glúten · sésamo"},
  {id:"almondegas",name:"Almôndegas de vaca em molho de tomate, puré de batata",desc:"Almôndegas de vaca em molho de tomate caseiro, com puré.",al:"Leite"},
  {id:"ossobuco",name:"Ossobuco de vitela com esmagada de batata",desc:"Estufado lento com osso, que ganha sabor no dia seguinte. Com esmagada de batata e azeite.",al:"Aipo · sulfitos"},
  {id:"gratinado",name:"Massa gratinada com brócolos e queijo",desc:"Vegetariano. Penne com brócolos em molho de queijo, gratinada no forno.",al:"Glúten · leite"}
];
const DISH_IMG=(window.MARMITA_IMG||{});
const PRICE={5:45,10:90}, FEE=3.9;
const EXAMPLE={pack:5,q:{},nome:"",loc:"",mode:"entrega",addr:"",cp:""};
const cpOk=v=>/^\d{4}-\d{3}$/.test(v||"");
let S=JSON.parse(JSON.stringify(EXAMPLE));
const $=id=>document.getElementById(id);
const eur=n=>n.toFixed(2).replace(".",",")+" €";
const total=()=>Object.values(S.q).reduce((a,b)=>a+b,0);

function buildDishes(){
  $("dishes").innerHTML=DISHES.map(d=>{const src=DISH_IMG[d.id]||"";return `
    <article class="dish" data-id="${d.id}">
      <div class="ph ${src?"has-img":""}">${src?`<img src="${src}" alt="${d.name}" loading="lazy">`:`<span>Fotografia em breve</span>`}</div>
      <div class="meta"><h3>${d.name}</h3><p>${d.desc}</p><span class="al">Alergénios: ${d.al}</span></div>
      <div class="stepper" role="group" aria-label="Quantidade de ${d.name}">
        <button type="button" data-d="-1" aria-label="Menos ${d.name}">–</button>
        <output aria-live="polite">0</output>
        <button type="button" data-d="1" aria-label="Mais ${d.name}">+</button>
      </div>
    </article>`}).join("");
  $("dishes").addEventListener("click",e=>{
    const b=e.target.closest("button[data-d]");if(!b)return;
    const id=b.closest(".dish").dataset.id, d=+b.dataset.d;
    const cur=S.q[id]||0, nv=Math.max(0,cur+d);
    if(d>0&&total()>=S.pack)return;
    if(nv)S.q[id]=nv;else delete S.q[id];
    render();
  });
}

function message(){
  const lines=DISHES.filter(d=>S.q[d.id]).map(d=>`• ${S.q[d.id]}× ${d.name}`);
  const fee=(S.mode==="entrega"&&S.pack===5)?FEE:0;
  let m=`Olá! Quero encomendar o Pack ${S.pack} (${eur(PRICE[S.pack])}):\n`;
  m+=lines.length?lines.join("\n"):"• (ainda sem pratos)";
  const left=S.pack-total();
  if(left>0)m+=`\n• (faltam ${left})`;
  m+=`\n\nNome: ${S.nome||"…"}\n`;
  if(S.mode==="entrega")m+=`Entrega${fee?` (+${eur(fee)})`:" (grátis)"}:\n${S.addr||"…"}\n${S.cp||"0000-000"} ${S.loc||"…"}\n`;
  else m+=`Recolha (grátis) · Foros de Salvaterra\n`;
  m+=`Total: ${eur(PRICE[S.pack]+fee)}`;
  return m;
}

function render(){
  const t=total(), left=S.pack-t, over=t>S.pack;
  $("p5").setAttribute("aria-pressed",S.pack===5);$("p10").setAttribute("aria-pressed",S.pack===10);
  $("mEnt").setAttribute("aria-pressed",S.mode==="entrega");$("mRec").setAttribute("aria-pressed",S.mode==="recolha");
  $("mEnt").textContent=S.pack===5?"Entrega + 3,90 €":"Entrega grátis";
  const ent=S.mode==="entrega";
  $("addrWrap").hidden=!ent;$("cpWrap").hidden=!ent;$("cpRow").hidden=!ent;$("recInfo").hidden=ent;
    $("cpErr").hidden=!(ent&&S.cp.length===8&&!cpOk(S.cp))&&!(ent&&S.cp.length>0&&S.cp.length<8&&document.activeElement!==$("cp"));
  $("count2").textContent=`(${t} de ${S.pack})`;
  $("count").textContent=`${t} de ${S.pack} refeições${t===S.pack?" ✓":""}`;
  $("hint").textContent=over?`Tens ${t} pratos. Tira ${t-S.pack} ou muda para o Pack 10.`:left>0?`Escolhe mais ${left}.`:"Pack completo.";
  $("bar").style.width=Math.min(100,t/S.pack*100)+"%";
  document.querySelectorAll(".dish").forEach(el=>{
    const q=S.q[el.dataset.id]||0;el.querySelector("output").textContent=q;
    el.querySelector(".stepper").classList.toggle("on",q>0);
    el.querySelector('[data-d="-1"]').disabled=q===0;
    el.querySelector('[data-d="1"]').disabled=t>=S.pack;
  });
  const msg=message();
  $("msg").innerHTML="";$("msg").append(document.createTextNode(msg));
  const now=new Date();const tm=document.createElement("small");tm.textContent=now.toTimeString().slice(0,5)+" ✓✓";$("msg").append(tm);
  const ready=t===S.pack&&S.nome.trim()&&(S.mode==="recolha"||(S.loc.trim()&&S.addr.trim()&&cpOk(S.cp)));
  const send=$("send");
  if(ready){send.setAttribute("aria-disabled","false");send.textContent="Encomendar pelo WhatsApp";send.href=`https://wa.me/${PHONE}?text=${encodeURIComponent(msg)}`;}
  else{send.setAttribute("aria-disabled","true");send.href="#";
    send.textContent=t!==S.pack?(left>0?`Escolhe mais ${left} refeiç${left===1?"ão":"ões"}`:"Tira pratos a mais"):"Preenche os teus dados";}
  $("sticky").classList.toggle("show",t>0);
  $("reset").hidden=!(t>0||S.nome||S.loc||S.addr||S.cp);
  $("stPack").textContent=`Pack ${S.pack} · ${eur(PRICE[S.pack])}`;
  $("stCount").textContent=`${t} de ${S.pack} escolhidas${t===S.pack?" ✓":""}`;
  $("stBtn").textContent=ready?"Ver mensagem":"Ver encomenda";
}

function bind(){
  $("p5").onclick=()=>{S.pack=5;render()};$("p10").onclick=()=>{S.pack=10;render()};
  $("mEnt").onclick=()=>{S.mode="entrega";render()};$("mRec").onclick=()=>{S.mode="recolha";render()};
  $("cp").value=S.cp;$("cp").addEventListener("input",e=>{let d=e.target.value.replace(/\D/g,"").slice(0,7);if(d.length>4)d=d.slice(0,4)+"-"+d.slice(4);e.target.value=d;S.cp=d;render()});
  $("cp").addEventListener("blur",render);
  [["nome","nome"],["loc","loc"],["addr","addr"]].forEach(([id,k])=>{$(id).value=S[k];$(id).addEventListener("input",e=>{S[k]=e.target.value;render()})});
  $("reset").onclick=()=>{S={pack:S.pack,q:{},nome:"",loc:"",mode:"entrega",addr:"",cp:""};["nome","loc","addr","cp"].forEach(i=>$(i).value="");render()};
  document.querySelectorAll("[data-pick]").forEach(a=>a.addEventListener("click",()=>{S.pack=+a.dataset.pick;render()}));
}
buildDishes();bind();render();
(function(){const hd=document.querySelector("header.site"),hero=document.querySelector(".hero"),mq=window.matchMedia("(max-width:820px)");let last=window.scrollY;
  const upd=()=>{const y=window.scrollY,solid=mq.matches?y>hero.offsetHeight-90:y>8;if(!mq.matches)document.documentElement.style.setProperty("--hd-h",hd.offsetHeight+"px");hd.classList.toggle("solid",solid);
    let hide=false;if(mq.matches&&y>140){hide=y>last+2?true:(y<last-2?false:hd.classList.contains("hide"));}
    hd.classList.toggle("hide",hide);document.body.classList.toggle("scrolled",solid&&!hide);last=y;};
  window.addEventListener("scroll",upd,{passive:true});window.addEventListener("resize",upd);upd();})();
